// TODO: Import React module
import * as React from 'react';
import { useSearchParams } from 'react-router-dom';

// TODO: Import MUI module;
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// TODO: Import MUI icon;

// TODO: Import custom component
import { FetchData } from '../../common/common.js';

export default function Medic() {
    // TODO: Define useContext

    // TODO: Define variable
    const [searchParams] = useSearchParams();

    const [medic, setMedic] = React.useState('');

    // TODO: Define event
    React.useEffect(() => {
        const formData = new FormData();
        formData.append('action', 'GetMedic');
        formData.append('id', searchParams.get('id'));

        FetchData(
            'https://www.pohtyh.edu.hk/YiYuan/webservices.php',
            formData,
            ((result) => { setMedic(result); })
        );

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // TODO: Define function

    // TODO: Return component
    return (
        medic.length > 0 &&
        <Box sx={{ m: 2 }}>
            <Typography
                color="success.dark"
                component="p"
                gutterBottom
                sx={{ fontWeight: 'bold' }}
                variant="h5">
                藥用價值
            </Typography>
            <Typography
                component="p"
                gutterBottom
                sx={{ color: '#000' }}
                variant="body"
            >
                {medic}
            </Typography>
        </Box>
    );
}